import React, { useState, useEffect } from "react";
import { Route, Link, Switch, useParams } from "react-router-dom";
import '../../util/Quiz.css';
import authHeader from '../../services/auth-header';
import quizService from "../../services/quiz.service";

const MultipleChoiceQuestion = ({ question, handleOptionSelect, selectedOptions }) => (
    <div>
        {question.choices.map((choice, i) => (
            <div key={i}>
                <label>
                    <input
                        className="quiz-page-radio-input"
                        type="radio"
                        name={`question_${question._id}`}
                        value={choice}
                        onChange={(e) => {
                            const isChecked = e.target.checked;
                            handleOptionSelect(choice, isChecked)
                        }}
                        checked={selectedOptions.includes(choice)}
                    />
                    <span className="quiz-page-option-prompt quiz-page-radio-input-prompt">{choice}</span>
                </label>
            </div>
        ))}
    </div>
);


// const ChooseAllThatApplyQuestion = ({ question, handleOptionSelect, selectedOptions }) => (
//   <div>
//     {question.choices.map((choice, i) => (
//       <div key={i}>
//         <label>
//           <input
//             type="checkbox"
//             name={`question_${question._id}`}
//             value={choice}
//             onChange={(e) => {
//               const isChecked = e.target.checked;
//               handleOptionSelect(choice, isChecked);}}
//             checked={selectedOptions.includes(choice)}
//           />
//           <span className="quiz-page-option-prompt">{choice}</span>
//         </label>
//       </div>
//     ))}
//   </div>
// );

const ChooseAllThatApplyQuestion = ({ question, handleOptionSelect, selectedOptions }) => (
    <div>
        {question.choices.map((choice, i) => (
            <div key={i}>
                <label>
                    <input
                        type={question.type === "ChooseAllThatApplyQuestion" ? "checkbox" : "radio"}
                        name={`question_${question._id}`}
                        value={choice}
                        onChange={(e) => {
                            const isChecked = e.target.checked;
                            handleOptionSelect(choice, isChecked, question);
                        }}
                        checked={selectedOptions.includes(choice)}
                    />
                    <span className="quiz-page-option-prompt">{choice}</span>
                </label>
            </div>
        ))}
    </div>
);

const QuizPage = ({ quiz, onFinishQuiz }) => {

    const { questions, num_questions } = quiz;

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isCorrect, setIsCorrect] = useState(null);

    const currentQuestion = questions[currentQuestionIndex];

    const handleOptionSelect = (option, isChecked, question) => {
        if (isChecked) {
            if (question.type === "ChooseAllThatApplyQuestion") {
                setSelectedOptions([...selectedOptions, option]);

            } else {
                // setSelectedOptions([...selectedOptions, option]);
                setSelectedOptions([option]);
            }
        } else {
            setSelectedOptions(selectedOptions.filter(item => item !== option));
        }
        console.log("selectedOptions: ", selectedOptions, question.type === "ChooseAllThatApplyQuestion");
    };

    const checkAnswer = () => {
        const correctAnswers = currentQuestion.answers.sort();
        const selectedAnswers = selectedOptions.sort();

        const isCorrect = JSON.stringify(correctAnswers) === JSON.stringify(selectedAnswers);
        setIsCorrect(isCorrect);
    };

    const handleSubmit = () => {
        onFinishQuiz();
    };

    const handleNextQuestion = async () => {
        setSelectedOptions([]);
        setIsCorrect(null);
        // Send the current question ID and quizAttempt ID to the backend
        const author = JSON.parse(localStorage.getItem("user")).username;
        console.log("Updating quiz take: ", quiz.quiz_attempt_id, currentQuestion.question_id);
        try {
            const response = await quizService.takeQuizUpdate(author, quiz.quiz_attempt_id, currentQuestion.question_id);
            console.log("take quiz updated: ", response);
            if (response.statusText = "OK") {
                setCurrentQuestionIndex(currentQuestionIndex + 1);
            } else {
                console.error('Failed to update quiz attempt');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
    return (
        <div className="container">
            <div>
                <div className="exit-quiz-container">
                    <Link to={`/quiz/list`} className="btn btn-danger exit-quiz-button">
                        Exit Quiz
                    </Link>
                </div>
                <div className="quiz-page-title">{quiz.title}</div>
                <p> Number of Questions: {num_questions}</p>
                {/* <p> Date: {quiz.date}</p> */}
                <hr className="quiz-title-hr" />
                {currentQuestion ? (
                    <>
                        <div className="quiz-page-question-title">Question {currentQuestionIndex + 1}</div>
                        <div className="quiz-page-question-content">
                            <div className="quiz-page-question-prompt">{currentQuestion.prompt}</div>
                            {/* {currentQuestion.type === "MultipleChoiceQuestion" && (
                <MultipleChoiceQuestion
                  question={currentQuestion}
                  handleOptionSelect={handleOptionSelect}
                  selectedOptions={selectedOptions}
                />
              )} */}
                            {/* {currentQuestion.type === "ChooseAllThatApplyQuestion" && (
                <ChooseAllThatApplyQuestion
                  question={currentQuestion}
                  handleOptionSelect={handleOptionSelect}
                  selectedOptions={selectedOptions}
                />
              )} */}
                            <ChooseAllThatApplyQuestion
                                question={currentQuestion}
                                handleOptionSelect={handleOptionSelect}
                                selectedOptions={selectedOptions}
                            />
                        </div>
                        <div className="quiz-page-btn-row">
                            <button className="btn btn-secondary" onClick={checkAnswer}>Check Answer</button>

                            {isCorrect !== null && (
                                <span>{isCorrect ? 'Correct!' : 'Incorrect.'}</span>
                            )}

                            {isCorrect && (
                                <button className="btn btn-primary"
                                    onClick={handleNextQuestion}>Next Question</button>
                            )}
                        </div>

                    </>
                ) : (
                    <>
                        <p>Congratulations! You've completed {questions.length}/{quiz.num_questions} questions.</p>
                        <Link to={`/quiz/list`} className="quiz-link">Go back</Link>
                        {/* <button onClick={handleSubmit}>Go back</button> */}
                    </>
                )}
            </div>
        </div>
    );
};

export default QuizPage;
